import React from 'react';

import './square-filter-image.scss';

import { IClassNames, makeClassNames } from '../../../utils/styles';
import { ISubSection } from '../../../typings/hlroom';
import { TypographyBody } from '../../foundation';

// FIXME create a proper interface for SquareFilterImage of create a generic IFilterImage
export interface IChipFilterImage {
  isDesktop: boolean;
  subSection: ISubSection;
  customClass?: string;
  onClick: (value: unknown) => void;
  selectedItem?: ISubSection;
  appType?: string;
}

const SquareFilterImage: React.FC<IChipFilterImage> = ({
  isDesktop = false,
  subSection,
  customClass,
  onClick,
  selectedItem,
  appType = 'sport',
}) => {
  const classNames = (isDesktop: boolean): IClassNames =>
    makeClassNames({
      squareFilterImg: [
        'square-filter-image',
        isDesktop && 'square-filter-image__desktop',
        customClass || '',
        customClass && isDesktop && `${customClass}__desktop`,
      ],
      squareFilterImgImage: ['square-filter-image__image', isDesktop && 'square-filter-image__image__desktop'],
      squareFilterImgText: ['square-filter-image__text'],
      squareFilterImgWrapper: [
        'square-filter-image__wrapper',
        subSection.tag === selectedItem?.tag && 'square-filter-image__wrapper--active',
      ],
    });
  const cn = classNames(isDesktop);

  return (
    <div className={cn.squareFilterImg} onClick={onClick}>
      <div className={cn.squareFilterImgWrapper}>
        {appType === 'tg24' ? (
          <span className={cn.squareFilterImgImage} />
        ) : (
          <img
            className={cn.squareFilterImgImage}
            src={subSection.images.squareFilter!.mobile}
            alt={subSection.images.squareFilter?.alt}
          />
        )}
        <span className={cn.squareFilterImgText}>
          <TypographyBody text={subSection.name} typographyClass="ty-body-m--headline-medium" />
        </span>
      </div>
    </div>
  );
};
export default SquareFilterImage;
